






















































































































import {
  defineComponent,
  onActivated,
  onMounted,
  ref,
} from "@vue/composition-api";
import getJianTou from "@/assets/images/jiantou@3x.png";
import Navigation from "./components/Navigation.vue";
import PestCard from "./components/PestCard.vue";
import { changeType, getTypeImage } from "@/utils/business";
import { swipe } from "@/utils/swipe";
import {
  getDiseasePestTree,
  getPestList,
  IResPest,
  PestItemType,
  SubItem,
} from "@/api/diseasePest";
import router from "@/router";
import { goBack } from "@/utils/goBack";
import { JSCallAPP } from "@/utils/interactive";

export type ListDataType = {
  infoList: IResPest[];
  refreshing: boolean;
  finished: boolean;
  loading: boolean;
  page: number;
  size: number;
  loosingText: string;
  finishedText: string;
  toEnd: boolean;
  row: number;
};

export default defineComponent({
  components: {
    Navigation,
    PestCard,
  },
  setup() {
    
    const showAllClass = ref(false);
    const activeTab = ref(0);
    const scrollListRef = ref<HTMLDivElement | null>(null);
    const scrollCropRef = ref<HTMLDivElement | null>(null);
    const pubData = ref<PestItemType[]>([]);
    const subData = ref<SubItem[]>([]);
    const selectedPubCrop = ref(0);
    const selectedSubCrop = ref(0);
    const lastSubCrop = ref(0);
    const firstSubCrop = ref(0);
    const showDisease = ref(false);
    const showPest = ref(false);
    const diseaseCount = ref(0);
    const scrollPos = ref(0);
    const overlayShow = ref(true);
    const listData = ref<ListDataType>({
      infoList: [],
      refreshing: false,
      finished: false,
      loading: false,
      page: 1,
      size: 40,
      loosingText: "释放即可刷新...",
      finishedText: "上滑 至下一分类",
      toEnd: false,
      row: 0,
    });

    //获取分类数据
    const getDataApi = async () => {
      const [err, data] = await getDiseasePestTree();
      if (!err && data != null && data != undefined) {
        overlayShow.value = false;
        data.forEach((item, index) => {
          pubData.value.push({
            image: getTypeImage(changeType(item.id)),
            checked: index == 0 ? "checked-" : "",
            ...item,
          });
          if (index == 0) {
            item.subsets.forEach((value, i) => {
              subData.value.push({
                checked: i == 0 ? "checked-" : "",
                ...value,
              });
            });
            selectedPubCrop.value = item.id;
            firstSubCrop.value = selectedSubCrop.value = item.subsets[0].id;
          }
          if (index == pubData.value.length - 1) {
            const subCount: number = item.subsets.length;
            lastSubCrop.value = item.subsets[subCount - 1].id;
          }
        });
        if (selectedSubCrop.value) {
          handleStart(false);
        }
      }
    };

    //获取大类单元格宽度
    const getSingelCropWidth = (index: number, length: number) => {
      let singleCardOffset = 0;
      let pos = 0;
      if (scrollCropRef.value) {
        const bodyContainer = scrollCropRef.value;
        if (singleCardOffset === 0) {
          const pestCardList = bodyContainer.getElementsByClassName("pub-card");
          pos = length > 1 && index == 0 ? 1 : 0;
          if (pestCardList.length && pestCardList[pos]) {
            const checkedElement = pestCardList[pos] as HTMLDivElement;
            singleCardOffset = parseFloat(
              getComputedStyle(checkedElement).width
            );
            singleCardOffset += parseFloat(
              getComputedStyle(checkedElement).paddingRight
            );
          }
        }
      }
      return singleCardOffset;
    };

    //移动大类位置
    const changePubPos = (index: number) => {
      let pos = 0;
      if (scrollCropRef.value) {
        if (index <= 2) {
          pos = 0;
        } else if (index > 2 && index < pubData.value.length - 2) {
          pos = (index - 2) * getSingelCropWidth(index, pubData.value.length);
        } else {
          pos = index * getSingelCropWidth(index, pubData.value.length);
        }
        scrollCropRef.value.scrollTo({ left: pos, behavior: "smooth" });
      }
    };

    //切换分类
    const changeNextCrop = (direc: string) => {
      let changePub = false;
      if (direc == "up") {
        let pos = 0;
        subData.value.forEach((item: SubItem, index: number) => {
          if (item.id == selectedSubCrop.value) {
            if (index < subData.value.length - 1) {
              //不是最后一个小类，取当前小类的后一个小类
              item.checked = "";
              pos = index + 1;
              subData.value[pos].checked = "checked-";
            } else {
              //是最后一个小类。需要判断大类
              changePub = true;
            }
          }
        });
        if (pos > 0) {
          selectedSubCrop.value = subData.value[pos].id;
        }

        if (changePub) {
          let pos = 0;
          pubData.value.forEach((item: PestItemType, index: number) => {
            if (item.id == selectedPubCrop.value) {
              if (index < pubData.value.length - 1) {
                //不是最后一个大类
                item.checked = "";
                pos = index + 1;
                pubData.value[pos].checked = "checked-";
                subData.value = [];
                pubData.value[pos].subsets.forEach((value, i) => {
                  subData.value.push({
                    checked: i == 0 ? "checked-" : "",
                    ...value,
                  });
                });
              }
              // 最后一个大类
            }
          });
          if (pos > 0) {
            selectedPubCrop.value = pubData.value[pos].id;
            selectedSubCrop.value = pubData.value[pos].subsets[0].id;
            changePubPos(pos);
          }
        }
      } else {
        subData.value.forEach((item: SubItem, index: number) => {
          if (item.id == selectedSubCrop.value) {
            if (index > 0) {
              //不是第一个小类
              item.checked = "";
              let pos = index - 1;
              selectedSubCrop.value = subData.value[pos].id;
              subData.value[pos].checked = "checked-";
            } else {
              //是第一个小类，跳到上一个大类的最后一个小类
              changePub = true;
            }
          }
        });
        if (changePub) {
          pubData.value.forEach((item: PestItemType, index: number) => {
            if (item.id == selectedPubCrop.value) {
              if (index > 0) {
                item.checked = "";
                //不是第一个大类
                let pos = index - 1;
                pubData.value[pos].checked = "checked-";
                subData.value = [];
                let poss = pubData.value[pos].subsets.length - 1;
                pubData.value[pos].subsets.forEach((value, i) => {
                  subData.value.push({
                    checked: i == poss ? "checked-" : "",
                    ...value,
                  });
                });
                selectedPubCrop.value = pubData.value[pos].id;
                selectedSubCrop.value = pubData.value[pos].subsets[poss].id;
                changePubPos(pos);
              }
              //第一个大类不刷新
            }
          });
        }
      }
    };

    //选择大类
    const handleChooseCropId = (id: number) => {
      showAllClass.value = false;
      subData.value = [];
      pubData.value.forEach((item: PestItemType, index: number) => {
        item.checked = "";
        if (item.id == id) {
          item.checked = "checked-";
          item.subsets.forEach((value, i) => {
            subData.value.push({
              checked: i == 0 ? "checked-" : "",
              ...value,
            });
          });
          selectedPubCrop.value = item.id;
          selectedSubCrop.value = item.subsets[0].id;
          changePubPos(index);
        }
      });

      if (selectedSubCrop.value) {
        if (scrollListRef.value != null) {
          scrollListRef.value.scrollTop = 0;
        }
        handleStart(false);
      }
    };
    //选择小类
    const handleSubCropId = (id: number) => {
      subData.value.forEach((item: SubItem) => {
        item.checked = "";
        if (item.id == id) {
          item.checked = "checked-";
          selectedSubCrop.value = item.id;
        }
      });
      if (selectedSubCrop.value) {
        if (scrollListRef.value != null) {
          scrollListRef.value.scrollTop = 0;
        }
        handleStart(false);
      }
    };

    //打开全部浮层
    const handleAllCrop = () => {
      showAllClass.value = true;
    };

    //判断是否显示病害或虫害类型
    const showType = () => {
      showDisease.value = false;
      showPest.value = false;
      diseaseCount.value = 0;
      listData.value.infoList.forEach((item) => {
        if (item.type == 1) {
          showDisease.value = true;
          diseaseCount.value = diseaseCount.value + 1;
        }
        if (item.type == 2) {
          showPest.value = true;
        }
      });
    };

    //获取病虫害数据
    const handleStart = async (up?: boolean) => {
      const param = {
        status: 1,
        sort: 1,
        cropId: selectedSubCrop.value,
        page: up ? listData.value.page : 1,
        size: listData.value.size,
      };
      const [err, data] = await getPestList(param);
      if (!err && data != null && data.data != null) {
        if (param.page > 1) {
          //加载多页
          listData.value.infoList = listData.value.infoList.concat(data.data);
        } else {
          //加载更新
          listData.value.infoList = [];
          listData.value.infoList = data.data;
        }
        if (param.page < data.maxPageNumber) {
          listData.value.finished = false;
          listData.value.page = listData.value.page + 1;
          listData.value.finishedText = "加载更多";
          listData.value.row = 0;
        } else {
          //更换分类
          if (selectedSubCrop.value == lastSubCrop.value) {
            listData.value.finishedText = "加载完成";
            listData.value.toEnd = true;
          } else {
            listData.value.finishedText = "上滑 至下一分类";
            listData.value.toEnd = false;
          }
          if (selectedSubCrop.value == firstSubCrop.value) {
            listData.value.loosingText = "释放即可刷新...";
          } else {
            listData.value.loosingText = "下拉 至上一分类";
          }

          listData.value.finished = true;
          listData.value.page = 1;
        }
      }
      showType();
      setTimeout(() => {
        if (listData.value.refreshing) {
          listData.value.refreshing = false;
        }
        listData.value.loading = false;
      }, 200);
    };

    //下拉刷新
    const handleRefresh = () => {
      listData.value.page = 1;
      listData.value.finished = false;
      listData.value.loading = true;
      changeNextCrop("down");
      handleStart(false);
    };

    //计算滑动位置
    let singleCardOffset = 0;
    const getCurrentTopItem = () => {
      if (scrollListRef.value) {
        const bodyContainer = scrollListRef.value;
        if (singleCardOffset === 0) {
          const pestCardList = bodyContainer.getElementsByClassName(
            "pest-card"
          );
          if (pestCardList.length && pestCardList[0]) {
            const firstElement = pestCardList[0] as HTMLDivElement;
            singleCardOffset = parseFloat(
              getComputedStyle(firstElement).height
            );
            singleCardOffset += parseFloat(
              getComputedStyle(firstElement).paddingBottom
            );
          }
        }
        if (singleCardOffset !== 0) {
          const localIndex = parseInt(
            (bodyContainer.scrollTop / singleCardOffset).toFixed(0),
            10
          );

          if (process.env.NODE_ENV === "development") {
            console.log(
              `当前滚动条位置：${
                bodyContainer.scrollTop
              }，单个模块高度：${singleCardOffset}，当前选中的模块序号：${localIndex}，scroll高度：${parseFloat(
                getComputedStyle(bodyContainer).height
              )}`
            );
          }

          return [
            localIndex,
            singleCardOffset,
            parseFloat(getComputedStyle(bodyContainer).height),
            bodyContainer.scrollTop,
          ];
        }
      }
      return [0, 0, 0, 0];
    };

    //改变病虫害类型高亮显示
    const handleChangeType = () => {
      const index = getCurrentTopItem();
      activeTab.value =
        listData.value.infoList.length > index[0]
          ? listData.value.infoList[index[0]].type == 1
            ? 0
            : 1
          : 0;
    };

    const changeCrop = () => {
      const index = getCurrentTopItem();
      if (
        listData.value.finished == true &&
        !listData.value.toEnd &&
        index[0] >= listData.value.infoList.length - 3
      ) {
        changeNextCrop("up");
        handleStart(true);
        setTimeout(() => {
          if (scrollListRef.value != null) {
            scrollListRef.value.scrollTop = 0;
          }
        }, 200);
      }
    };

    onMounted(() => {
      getDataApi();
      if (scrollListRef.value) {
        swipe(scrollListRef.value, {
          onSwipeUp: () => {
            changeCrop();
          },
        });
      }
    });

    onActivated(() => {
      if (scrollListRef.value) {
        scrollListRef.value.scrollTop = scrollPos.value;
      }
    });
    let scrollTimer: number | null = null;
    //监听滑动事件
    const scrollEvent = () => {
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }
      scrollTimer = setTimeout(() => {
        handleChangeType();
      }, 100);
    };

    const onClickTab = (name: number) => {
      const index = getCurrentTopItem();
      if (scrollListRef.value != null) {
        scrollListRef.value.scrollTop =
          name == 0 ? 0 : index[1] * diseaseCount.value;
      }
    };

    //点击病虫害详情
    const handleToDetail = (value: number) => {
      const index = getCurrentTopItem();
      scrollPos.value = index[3];
      JSCallAPP({
        method: "pest_detail",
        data: {
          url: ("/pest/pestDetail?id=" + (value as unknown)) as string,
        },
      });
    };

    //跳转到搜索页面
    const handleSearch = (text: string) => {
      JSCallAPP({
        method: "pest_search",
        data: {
          url: "/pest/pestSearch",
          title: text,
        },
      });
    };

    const handleBack = () => {
      goBack();
    };

    return {
      showAllClass,
      handleAllCrop,
      handleChooseCropId,
      handleSubCropId,
      getJianTou,
      listData,
      activeTab,
      showDisease,
      showPest,
      scrollListRef,
      onClickTab,
      pubData,
      subData,
      handleBack,
      handleSearch,
      pageTitle: "",
      handleRefresh,
      handleToDetail,
      handleStart,
      scrollEvent,
      scrollCropRef,
      overlayShow,
    };
  },
});
